const heading_text_desktop = {
    fontFamily: "Red Hat Display, sans-serif",
    color: "#fff",
    fontSize: "7vw",
};

const descriptive_text_desktop = {
    fontFamily: "Montserrat, sans-serif",
    color: "#fff",
    fontSize: "2vw",
};

const heading_text_mobile = {
    fontFamily: "Red Hat Display, sans-serif",
    color: "#fff",
    fontSize: "2.5vh",
};

const sub_heading_text_mobile = {
    fontFamily: "Montserrat, sans-serif",
    color: "#fff",
    fontSize: "2vh",
};

const descriptive_text_mobile = {
    fontFamily: "Montserrat, sans-serif",
    color: "#fff",
    fontSize: "3vw",
};

const heading_game_text_desktop = {
    fontFamily: "VT323, monospace",
    color: "rgb(93, 246, 17)",
    fontSize: "7vw",
};

const descriptive_game__text_desktop = {
    fontFamily: "VT323, monospace",
    color: "#fff",
    fontSize: "2vw",
};

export {
    heading_text_desktop,
    descriptive_text_desktop,
    heading_text_mobile,
    sub_heading_text_mobile,
    descriptive_text_mobile,
    heading_game_text_desktop,
    descriptive_game__text_desktop,
};
